import type { JSX } from "preact";
import { DAO } from "./DAO";
import { News } from "./News";
import "./styles.css";

export function Index(): JSX.Element {
    DAO.init();

    return <News />;
}
